module.exports = __webpack_public_path__ + "static/media/MOTIVATION_MIXED.db666d97.md";